module.exports = __webpack_public_path__ + "static/img/new_logo_3.9f5e4ce7.png";